import { useEventListener } from "usehooks-ts"
import { r2ImageUrl } from "~shared/r2"

interface ImageLightboxProps {
	alt: string
	imageUrl: string
	onClose: () => void
}

export function ImageLightbox({ alt, imageUrl, onClose }: ImageLightboxProps) {
	useEventListener("keydown", (e: KeyboardEvent) => {
		if (e.key === "Escape") {
			onClose()
		}
	})

	return (
		<dialog
			aria-label={alt || "Image preview"}
			className="fade-in fixed inset-0 z-50 flex h-full max-h-full w-full max-w-full animate-in items-center justify-center border-0 bg-black/80 p-4 duration-200 open:flex"
			onClick={onClose}
			onKeyDown={() => {}}
			open
		>
			{/* biome-ignore lint/a11y/useKeyWithClickEvents: keyboard handled by document listener */}
			<img
				alt={alt}
				className="max-h-[90vh] max-w-[90vw] animate-scale-in rounded-lg object-contain"
				onClick={e => e.stopPropagation()}
				src={r2ImageUrl(imageUrl, {
					width: Math.min(1600, Math.round(window.innerWidth * 0.9 * devicePixelRatio)),
				})}
			/>
		</dialog>
	)
}
